import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { formatFCFA, imageUrl } from "../lib/format";
import { Button } from "../components/ui/button";
import { TrustBadges } from "../components/storefront/TrustBadges";
import { Trash2, Minus, Plus } from "lucide-react";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center">
        <h1 className="font-serif text-3xl text-[#2C1A14]">Votre panier est vide</h1>
        <p className="mt-3 text-[#9B7E73]">Découvrez nos pièces et laissez-vous tenter.</p>
        <Link to="/catalog">
          <Button data-testid="empty-cart-cta" className="mt-6 rounded-full bg-[#D76E4D] px-7 text-white hover:bg-[#C05A3A]">
            Explorer le Dressing
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:py-14">
      <h1 className="mb-8 font-serif text-3xl font-medium text-[#2C1A14] sm:text-4xl">Votre panier</h1>
      <div className="space-y-4">
        {items.map((it) => (
          <div
            key={`${it.product_id}-${it.taille}`}
            data-testid={`cart-item-${it.product_id}`}
            className="flex gap-4 rounded-xl bg-white p-4 ring-1 ring-[#E8D5CE]"
          >
            <img src={imageUrl(it.image)} alt={it.nom} className="h-24 w-20 rounded-lg object-cover" />
            <div className="flex flex-1 flex-col justify-between">
              <div>
                <h3 className="font-serif text-lg text-[#2C1A14]">{it.nom}</h3>
                <p className="text-xs text-[#9B7E73]">Taille : {it.taille}</p>
                <p className="mt-1 font-semibold text-[#D76E4D]">{formatFCFA(it.prix)}</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center rounded-full border border-[#E8D5CE]">
                  <button data-testid={`decrease-${it.product_id}`} onClick={() => updateQty(it.product_id, it.taille, it.quantite - 1)} className="px-2 py-1 text-[#6E544A]"><Minus className="h-4 w-4" /></button>
                  <span className="min-w-[2rem] text-center text-sm font-medium">{it.quantite}</span>
                  <button data-testid={`increase-${it.product_id}`} onClick={() => updateQty(it.product_id, it.taille, it.quantite + 1)} className="px-2 py-1 text-[#6E544A]"><Plus className="h-4 w-4" /></button>
                </div>
                <button data-testid={`remove-${it.product_id}`} onClick={() => removeItem(it.product_id, it.taille)} className="text-[#9B7E73] hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-xl bg-[#F5E8E3] p-6">
        <div className="flex items-center justify-between text-[#2C1A14]">
          <span>Sous-total</span>
          <span data-testid="cart-subtotal" className="font-semibold">{formatFCFA(subtotal)}</span>
        </div>
        <TrustBadges className="mt-4 border-t border-[#E8D5CE] pt-4" />
        <Button
          onClick={() => navigate("/commande")}
          data-testid="checkout-button"
          className="mt-5 w-full rounded-full bg-[#D76E4D] py-6 text-base text-white hover:bg-[#C05A3A]"
        >
          Passer la commande
        </Button>
      </div>
    </div>
  );
}
